import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-filter_pill_tile-view';
/**
 * Event when filter pill tile is viewed
 */
export function trackRetailersFilterPillTileView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
